// "náhled" mark for our own preview accounts: the feature exists but the organiser does
// not see it yet (switched off or not released, see GET /api/meta previewFeatures).
import React from 'react';
import { useMeta } from '../../contexts/MetaContext';

export default function PreviewBadge({ feature, className = '' }) {
  const meta = useMeta();
  if (!feature || !meta.isPreview(feature)) return null;
  return (
    <span
      title="Vidíš jen ty (náhledový účet) – organizátor tuto funkci zatím nevidí."
      className={`ml-2 rounded-full bg-fuchsia-600 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white ${className}`}
    >
      náhled
    </span>
  );
}
